import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input, Select } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { getObject } from "utils";
import { FormItem, TranslationFormItem } from 'utils/form_helpers';

import styles from "./form.module.css";


class ServiceForm extends Component {
    componentDidMount() {
        const { actions, service_group } = this.props;
        if (service_group.list.length === 0) {
            actions.serviceGroupLoad({ query: '' });
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const { actions, service } = this.props;
                const instance = service.editObject;

                let data = Object.assign({}, values);
                if (instance && instance.id) {
                    data.id = instance.id;
                }
                actions.serviceUpdate({ data });
            }
        });
    };

    close = () => {
        const { actions } = this.props;
        actions.serviceShowEditForm({ show: false });
    };

    render() {
        const { form, service, service_group } = this.props;
        const { showEditForm, updateStatus, editObject } = service;
        const instance = editObject;

        const error = updateStatus.error || {};
        const errorData = error.data || {};

        const isLoading = service.updateStatus.isLoading;

        return (
            <Modal
                visible={showEditForm}
                title="Редактирование услуги"
                onCancel={this.close}
                maskClosable={false}
                destroyOnClose={true}
                footer={[
                    <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
                    <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
                        Сохранить
                    </Button>,
                ]}
            >
                <Spin spinning={isLoading}>
                    <Form onSubmit={this.handleSubmit}>
                        {errorData.non_field_errors &&
                        <div className={styles.error}>{errorData.non_field_errors}</div>}

                        <FormItem
                            form={form}
                            instance={instance}
                            name="group"
                            label="Группа"
                            required={true}
                            errorData={errorData}
                        >
                            <Select
                                style={{ width: 300 }}
                                //dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                placeholder="Выберите группу"
                                //onChange={this.onChange}
                            >
                                {service_group.list.map(id => {
                                    const obj = getObject(service_group, id);
                                    return (
                                        <Select.Option key={`group${obj.id}`} value={obj.id}>{obj.name_en}</Select.Option>
                                    )
                                })}
                            </Select>
                        </FormItem>

                        <TranslationFormItem
                            form={form}
                            instance={instance}
                            name="name"
                            label="Название"
                            required={true}
                            errorData={errorData}
                        />

                        <FormItem
                            form={form}
                            instance={instance}
                            name="slug"
                            label="Путь"
                            required={true}
                            errorData={errorData}

                        >
                            <Input size="large"/>
                        </FormItem>

                        <FormItem
                            form={form}
                            instance={instance}
                            name="sort"
                            label="Сортировка"
                            required={true}
                            errorData={errorData}

                        >
                            <Input size="large"/>
                        </FormItem>
                    </Form>
                </Spin>
            </Modal>
        );
    }
}


const WrappedServiceForm = Form.create()(ServiceForm);

function mapStateToProps(state) {
    return {
        service: state.service,
        service_group: state.service_group,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, actions.service, actions.service_group), dispatch),
        dispatch: dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedServiceForm);

